export const beneficiaryRegisterTranslations = {
    en: {
        // Card Titles
        beneficiaryDetails: "Beneficiary Details",
        personalDetails: "Personal Details",
        addressDetails: "Address Details",
        healthDetails: "Health Details",
        abhaCardDetails: "ABHA Card Details",
        otherDetails: "Other Details",
        remarks: "Remarks",
        quickLookup: "Quick Lookup",
        quickLookupSubtitle: "Optional — prefill from an existing beneficiary record",
        byMobile: "By Mobile",
        byAadhar: "By Aadhaar",

        // Form Labels
        verificationMethod: "Verification Method",
        mobileNumber: "Mobile Number",
        aadharNumber: "Aadhar Number",
        beneficiaryName: "Beneficiary Name",
        email: "Email",
        gender: "Gender",
        dateOfBirth: "Date of Birth",
        maritalStatus: "Marital Status",
        selectMaritalStatus: "Select Marital Status",
        single: "Single",
        married: "Married",
        widowed: "Widowed",
        divorced: "Divorced",
        disease: "Disease",
        pincode: "Pincode",
        district: "District",
        taluka: "Taluka",
        villageName: "Village Name",
        abhaCard: "ABHA Card",
        abhaCardNumber: "ABHA Card Number",
        remark: "Remark",

        // Gender Options
        male: "Male",
        female: "Female",
        other: "Other",

        // Radio Options
        yes: "Yes",
        no: "No",

        // Buttons
        fetchDetails: "Fetch Details",
        submit: "Submit",
        processing: "Processing...",

        // Placeholders
        selectDistrict: "Select District",
        selectTaluka: "Select Taluka",

        // Validation Messages
        enterAtLeast2Chars: "Please enter at least 2 characters",
        enterName: "Please enter your name",
        mobileNumberInvalid: "Mobile number must be 10 digits starting with 6-9",
        enterValidMobile: "Please enter a valid mobile number",
        enterValidEmail: "Please enter a valid email",
        invalidPincode: "Invalid pincode",
        enterValidPincode: "Please enter a valid pincode",
        talukaRequired: "Taluka is required",
        districtRequired: "District is required",
        aadharNumberInvalid: "Aadhar number must be 12 digits",
        enterValidAadhar: "Please enter a valid Aadhar number",
        selectOption: "Please select an option",
        abhaCardNumberInvalid: "ABHA card number must be 14 digits",
        enterValidAbha: "Please enter a valid ABHA card number",
        selectDisease: "Please select a disease",
        selectValidGender: "Please select a valid gender",
        genderRequired: "Gender is required",
        dobFutureError: "Date of birth cannot be in the future",
        dobPastError: "Date of birth cannot be more than last 100 years",
        enterDOB: "Please enter your date of birth",

        // Snackbar Messages
        enterValid10DigitMobile: "Please enter a valid 10-digit mobile number",
        enterValid12DigitAadhar: "Please enter a valid 12-digit Aadhar number",
        detailsFetchedSuccess: "Beneficiary details fetched successfully",
        noBeneficiaryFound: "No existing beneficiary found. Please enter details for new registration.",
        beneficiaryRegisteredSuccess: "Beneficiary registered successfully",
        beneficiaryRegistrationFailed: "Failed to register beneficiary",
        beneficiaryStatusUpdatedSuccess: "Beneficiary status updated successfully",
        beneficiaryStatusUpdateFailed: "Failed to update beneficiary status",
        fetchDiseasesFailed: "Failed to fetch diseases",

        // Required Indicator
        required: "*",
    },
    mr: {
        // Card Titles
        beneficiaryDetails: "लाभार्थी तपशील",
        personalDetails: "वैयक्तिक तपशील",
        addressDetails: "पत्ता तपशील",
        healthDetails: "आरोग्य तपशील",
        abhaCardDetails: "ABHA कार्ड तपशील",
        otherDetails: "इतर तपशील",
        remarks: "शेरा",
        quickLookup: "त्वरित शोध",
        quickLookupSubtitle: "पर्यायी — विद्यमान लाभार्थी रेकॉर्डवरून आपोआप भरा",
        byMobile: "मोबाइलने",
        byAadhar: "आधारने",

        // Form Labels
        verificationMethod: "सत्यापन पद्धत",
        mobileNumber: "मोबाइल क्रमांक",
        aadharNumber: "आधार क्रमांक",
        beneficiaryName: "लाभार्थीचे नाव",
        email: "ईमेल",
        gender: "लिंग",
        dateOfBirth: "जन्मतारीख",
        maritalStatus: "वैवाहिक स्थिती",
        selectMaritalStatus: "वैवाहिक स्थिती निवडा",
        single: "अविवाहित",
        married: "विवाहित",
        widowed: "विधवा / विधुर",
        divorced: "घटस्फोटित",
        disease: "रोग",
        pincode: "पिनकोड",
        district: "जिल्हा",
        taluka: "तालुका",
        villageName: "गावाचे नाव",
        abhaCard: "ABHA कार्ड",
        abhaCardNumber: "ABHA कार्ड क्रमांक",
        remark: "शेरा",

        // Gender Options
        male: "पुरुष",
        female: "महिला",
        other: "इतर",

        // Radio Options
        yes: "होय",
        no: "नाही",

        // Buttons
        fetchDetails: "तपशील मिळवा",
        submit: "सबमिट करा",
        processing: "प्रक्रिया करत आहे...",

        // Placeholders
        selectDistrict: "जिल्हा निवडा",
        selectTaluka: "तालुका निवडा",

        // Validation Messages
        enterAtLeast2Chars: "कृपया किमान 2 वर्ण प्रविष्ट करा",
        enterName: "कृपया तुमचे नाव प्रविष्ट करा",
        mobileNumberInvalid: "मोबाइल क्रमांक 6-9 ने सुरू होणारा 10 अंकांचा असणे आवश्यक आहे",
        enterValidMobile: "कृपया वैध मोबाइल क्रमांक प्रविष्ट करा",
        enterValidEmail: "कृपया वैध ईमेल प्रविष्ट करा",
        invalidPincode: "अवैध पिनकोड",
        enterValidPincode: "कृपया वैध पिनकोड प्रविष्ट करा",
        talukaRequired: "तालुका आवश्यक आहे",
        districtRequired: "जिल्हा आवश्यक आहे",
        aadharNumberInvalid: "आधार क्रमांक 12 अंकांचा असणे आवश्यक आहे",
        enterValidAadhar: "कृपया वैध आधार क्रमांक प्रविष्ट करा",
        selectOption: "कृपया एक पर्याय निवडा",
        abhaCardNumberInvalid: "ABHA कार्ड क्रमांक 14 अंकांचा असणे आवश्यक आहे",
        enterValidAbha: "कृपया वैध ABHA कार्ड क्रमांक प्रविष्ट करा",
        selectDisease: "कृपया रोग निवडा",
        selectValidGender: "कृपया वैध लिंग निवडा",
        genderRequired: "लिंग आवश्यक आहे",
        dobFutureError: "जन्मतारीख भविष्यात असू शकत नाही",
        dobPastError: "जन्मतारीख गेल्या 100 वर्षांपेक्षा जास्त असू शकत नाही",
        enterDOB: "कृपया तुमची जन्मतारीख प्रविष्ट करा",

        // Snackbar Messages
        enterValid10DigitMobile: "कृपया वैध 10 अंकी मोबाइल क्रमांक प्रविष्ट करा",
        enterValid12DigitAadhar: "कृपया वैध 12 अंकी आधार क्रमांक प्रविष्ट करा",
        detailsFetchedSuccess: "लाभार्थी तपशील यशस्वीरित्या मिळवले",
        noBeneficiaryFound: "कोणताही विद्यमान लाभार्थी सापडला नाही. कृपया नवीन नोंदणीसाठी तपशील प्रविष्ट करा.",
        beneficiaryRegisteredSuccess: "लाभार्थी यशस्वीरित्या नोंदणीकृत",
        beneficiaryRegistrationFailed: "लाभार्थी नोंदणी अयशस्वी",
        beneficiaryStatusUpdatedSuccess: "लाभार्थी स्थिती यशस्वीरित्या अद्यतनित",
        beneficiaryStatusUpdateFailed: "लाभार्थी स्थिती अद्यतनित करण्यात अयशस्वी",
        fetchDiseasesFailed: "रोग मिळवण्यात अयशस्वी",

        // Required Indicator
        required: "*",
    }
};
